import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface BufferBudgetTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const BufferBudgetTour: React.FC<BufferBudgetTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.welcome.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="input-form"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.input_form.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.input_form.description')}</p>
                </div>
            ),
            placement: 'bottom',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="income-input"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.income_input.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.income_input.description')}</p>
                </div>
            ),
            placement: 'right',
        },
        {
            target: '[data-tour="date-input"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.date_input.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.date_input.description')}</p>
                </div>
            ),
            placement: 'right',
        },
        {
            target: '[data-tour="add-budget-button"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.add_budget_button.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.add_budget_button.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="calculation-settings"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.calculation_settings.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.calculation_settings.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="allocation-sliders"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.allocation_sliders.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.allocation_sliders.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="total-buffer-budget"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.total_buffer_budget.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.total_buffer_budget.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="budget-allocation-chart"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.budget_allocation_chart.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.budget_allocation_chart.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="total-income-display"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.total_income.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.total_income.description')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="income-records-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.income_records_table.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.income_records_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
        {
            target: '[data-tour="records-data-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.buffer_budget.records_data_table.title')}
                    </h3>
                    <p>{t('app_tour.buffer_budget.records_data_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];


    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="buffer-budget" steps={steps} navigateTo="/dashboard/tools/buffer-budget" />;
};

export default BufferBudgetTour;

